function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Prop, Component } from "vue-property-decorator";
import { State } from "vuex-class";
import V2OutlineCategory from "./category.vue";
import { isLangPack } from "@/views/creative/utils";
import { isHiddenCategory } from "@/views/creative/template/menu-sort-dialog/tree";
import { categoryConfig } from "@/store/creative/common/category";
var V2OutlineBd = /*#__PURE__*/ function(Vue1) {
    "use strict";
    _inherits(V2OutlineBd, Vue1);
    var _super = _createSuper(V2OutlineBd);
    function V2OutlineBd() {
        _classCallCheck(this, V2OutlineBd);
        return _super.apply(this, arguments);
    }
    _createClass(V2OutlineBd, [
        {
            key: "innerCategoryList",
            get: function get() {
                var _this = this;
                return this.categoryList.filter(function(item) {
                    var _this1 = _this;
                    var ref;
                    if (isLangPack({
                        prefix: item.prefix,
                        resourceType: item.resource_type
                    })) {
                        return true;
                    }
                    // 预设主分类
                    if (item.id === categoryConfig.preset.id) {
                        var ref1;
                        return Boolean((ref1 = item.sub_category) === null || ref1 === void 0 ? void 0 : ref1.length);
                    }
                    return Boolean((ref = item.sub_category) === null || ref === void 0 ? void 0 : ref.filter(function(cat) {
                        return !isHiddenCategory(cat, _this1.isCommonTemplatePage);
                    }).length);
                });
            }
        }
    ]);
    return V2OutlineBd;
}(Vue);
__decorate([
    Prop({
        type: Array
    })
], V2OutlineBd.prototype, "categoryList", void 0);
__decorate([
    State(function(state) {
        return state.creative.template.isCommonTemplatePage;
    })
], V2OutlineBd.prototype, "isCommonTemplatePage", void 0);
V2OutlineBd = __decorate([
    Component({
        components: {
            V2OutlineCategory: V2OutlineCategory
        }
    })
], V2OutlineBd);
export { V2OutlineBd as default };
